import { createFileRoute } from '@tanstack/react-router'
import { BACKLINK_CHANGE_DAYS } from '@/lib/backlinks'
import { DomainFacet } from '../-facet'

export const Route = createFileRoute('/_app/$org/$host/backlinks/_list/gained')({
  component: GainedPage,
})

/**
 * The domains that have started linking here.
 *
 * The window is fixed rather than taken from a picker, and it is stated wherever
 * the list is: what is dated is when a link was first *seen*, which is not the
 * same as when it was placed, so a narrower window would only report how far the
 * crawl has come round.
 */
function GainedPage() {
  return (
    <DomainFacet
      title={`Gained in the last ${BACKLINK_CHANGE_DAYS} days`}
      status="gained"
      emptyLabel={`No new linking domain in the last ${BACKLINK_CHANGE_DAYS} days.`}
    />
  )
}
